<template>
    <div class="flex flex-col items-center justify-center min-h-screen bg-black">
        <div class="bg-white p-6 rounded-2xl shadow-lg text-center w-96">
            <div v-if="loading" class="flex flex-col items-center">
                <div class="loader mb-4"></div>
                <p class="text-gray-600 text-lg">Finalisation en cours...</p>
            </div>

            <div v-else>
                <div v-if="success" class="text-green-600">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto mb-4" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M5 13l4 4L19 7"></path>
                    </svg>
                    <p class="text-lg font-semibold">Réservation confirmée !</p>
                    <p class="text-gray-500 mt-2">Vous allez recevoir un e-mail de confirmation.</p>
                </div>

                <div v-else class="text-red-500">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto mb-4" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <path d="M18 6L6 18"></path>
                        <path d="M6 6l12 12"></path>
                    </svg>
                    <p class="text-lg font-semibold">Échec de la réservation</p>
                    <p class="text-gray-500 mt-2">{{ message }}</p>
                </div>

                <router-link to="/" class="bg-blue-500 mt-4 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                    🏠 Accueil
                </router-link>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            success: false,
            message: "",
        };
    },
    created() {
        if (!localStorage.getItem("reservation_id")) {
            this.$router.push("/")
        } else {
            // const reservation = JSON.parse(localStorage.getItem("dataReservation"));

            // Envoi des données sans session_id
            this.axios.post(`${this.$store.state.api}/reservation/${localStorage.getItem("reservation_id")}`, "")
                .then(({ data }) => {
                    console.log(data)
                    this.success = true;
                    this.message = "Votre réservation a été enregistrée avec succèss !";
                    // this.$store.state.tables.filter((item, index) => item.id == JSON.parse(localStorage.getItem("dataReservation")).tableId ? this.$store.state.tables[index].capacity-- : "")

                    setTimeout(() => {
                        localStorage.clear()
                        this.$router.push("/")
                    }, 3000);
                })
                .catch(error => {
                    
                    this.success = false;
                    this.message = "Erreur lors de la réservation : " + (error.response?.data?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style>
.loader {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border-left-color: #000;
    animation: spin 1s ease infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
